import { Image } from "@repo/components/src/ui/image";
import { MediaViewerProps } from "../types";

const ImageContent = (props: MediaViewerProps) => {
  const postContent = props.postContent;
  const videoFile = postContent.content;
  return (
    <Image
      source={{ uri: videoFile?.url }}
      size="full"
      contentFit="contain"
      alt="PostContent"
    />
  );
};

export default ImageContent;
